module.exports = __webpack_public_path__ + "static/assets/ab0b450de68a74e9d7a8a773f0bd6204.svg";